export class PagingModel {
    constructor(currentPage, hasNext, hasPrevious, pageSize, totalPages, totalTotalItemCount) {
        this.currentPage = currentPage;
        this.hasNext = hasNext;
        this.hasPrevious = hasPrevious;
        this.pageSize = pageSize;
        this.totalPages = totalPages;
        this.totalTotalItemCount = totalTotalItemCount;
    }
    
    currentPage: number;
    hasNext: boolean;
    hasPrevious: boolean;
    pageSize: number;
    totalPages: number;
    totalTotalItemCount: number;
}